import { AnyAction, IPartialReducer } from "../../../../core/core-redux/reduxTypes";
import { extractFilterIdsForLayer } from "../../../util/featureFilterUtil";
import { Wfs3dLayersState } from "../../wfs3dLayers.reducer";
import { Feature } from "geojson";

export const wfs3dLayerPartialReducer: IPartialReducer<Wfs3dLayersState> = (
    state: Wfs3dLayersState,
    action: AnyAction
) => {
    const layerName = action.layerName;
    const layerGroup = action.layerGroup;
    const featureCollection = action.features;

    const layers = state.layers || [];
    const previousLayers = layers.filter(
        (previousLayer) => previousLayer.name === layerName && previousLayer.group === layerGroup
    );

    let layer: any;
    if (previousLayers && previousLayers.length > 0) {
        layer = previousLayers[0];
        featureCollection.features.forEach((feature: Feature) => layer.features.features.push(feature));
    } else {
        layer = {
            name: layerName,
            featureShortName: action.featureShortName,
            group: layerGroup,
            visible: state.visibleGroup === layerGroup && state.visibleLayers.includes(layerName),
            features: featureCollection,
        };
        layers.push(layer);
    }

    if (layer.features.features.length === state.layersFeatureCount[action.layerGroup][action.layerName].featureCount) {
        if (action.filters) {
            const filteredFeatures = extractFilterIdsForLayer(
                layer.name,
                layer.featureShortName,
                layer.features.features,
                action.filters
            );

            layer.visible = !!filteredFeatures;
            layer.filteredFeatures = filteredFeatures;
        } else {
            layer.filteredFeatures = layer.features.features.map((feature: Feature) => feature.properties!.featureId);
        }
    }

    return {
        layers: layers,
    };
};
